import { defineComponent as _defineComponent } from 'vue';
import { defineComponent, toRefs } from 'vue';
import { useHelpManager } from '@/entities/manager/model';
import CanIHelpYouBanner from './CanIHelpYouBanner.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CanIHelpYouBannerWrap',
  setup: function setup(__props) {
    defineComponent({
      name: 'CanIHelpYouBannerWrap'
    });
    var _toRefs = toRefs(useHelpManager()),
      manager = _toRefs.manager;
    return {
      __sfc: true,
      manager: manager,
      CanIHelpYouBanner: CanIHelpYouBanner
    };
  }
});